//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../Az/Header";
//Install
import Footer from "../../../Az/Footer";
//Install
import T723BA from "../../../../../Media/Image/030.jpg";
//Install
import Y477FT from "../../../../../Media/Image/046.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Haqqımızda : Temas Elektrik Müqaviləsi"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik, Davamlı və Etibarlı Enerji Xidmətləri ilə Hər Toxunuş Gələcəyə Dəyər Qatar."
        //Element
        let URL = "https://temaselektrik.com/az/haqqimizda"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Haqqımızda"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Elektriklə ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Toxun "
                                        ),
                                        //Element
                                        "Gələcəyə Bağlan."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Müqaviləsi, Enerji Sektorunda Etibarlı Həllər Təklif Etmək Məqsədi Ilə 1998-ci Ildə Təsis Olunmuşdur. Bu Gün Elektrik Müqaviləsi, Baxım Və Təmir, Layihə İnkişafı, Enerji Sistemləri Və Avtomatlaşdırma Sahələrində Xidmət Göstərir.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Dövlət Qurumlarından Sənaye Təsislərinə, KOBİ-lərdən Özəl Layihələrə Qədər Geniş Miqyasda Xidmət Göstərir. Bütün Fəaliyyətlərində Davamlılıq Və Keyfiyyət Prinsiplərini Ön Planda Tutur."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Bizim Üçün Hər Kabel Sadəcə Bir Bağlantı Deyil, Gələcəyə Uzanan Sağlam Bir Xətt Və Təhlükəsiz Tikililər Üçün Əsas Dəyərdir. Təcrübəmiz Və İnnovativ Yanaşmamızla Hər Layihəni Sabahlar Üçün Güclü Bir İnvestisiyaya Çeviririk."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        React.createElement("em", {},
                                            //Element
                                            "Temas Elektrik Müqaviləsi Məhdud Məsuliyyətli Şirkəti"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Haqqımızda", title: "Haqqımızda", src: T723BA, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB a562nn" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB n8122j" },
                                    //Element
                                    React.createElement("img", { alt: "Haqqımızda", title: "Haqqımızda", src: Y477FT, width: "1296", height: "auto" })
                                )
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB x010yw" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB h4517j" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB u16155" },
                                        //Element
                                        "Missiyamız"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x75t42" },
                                        //Element
                                        "Temas Elektrik Müqaviləsi olaraq; Elektriki Təhlükəsiz, Davamlı Və Səmərəli Həllərlə İdarə Edərək, Hər Layihədə Keyfiyyət, Etibar Və Texnologiya Yönümlü Həllər Təqdim Edərək Gələcəyə Dəyər Qatmaqdır."
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB h4517j" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB u16155" },
                                        //Element
                                        "Vizyonumuz"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x75t42" },
                                        //Element
                                        "Enerji Sektorunda Yenilikçi Texnologiyalar Və Etibarlı Tətbiqlərlə Gələcəyə Yön Verən Bir Marka Olmaq Və Hər Layihədə Davamlılığı, Keyfiyyəti Və Etibarı Gələcəyə Daşıyan Həllər Təqdim Etmək."
                                    )
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;